import React, { useState, useEffect } from 'react'
import { useAppSelector } from '../hooks'
import ProfileEditDialog from './ProfileEditDialog'

const RequiredProfileCheck: React.FC = () => {
  const userData = useAppSelector((state) => state.user.userData)
  // Guests have a placeholder user (no Parse profile to complete), often with no last name
  const isGuest = !!useAppSelector((state) => (state as any).guest?.guestContext)
  const [showProfileDialog, setShowProfileDialog] = useState(false)

  useEffect(() => {
    if (isGuest) {
      setShowProfileDialog(false)
      return
    }
    if (userData) {
      // Email verification must complete before we prompt for profile details
      if (userData.emailVerified === false) {
        setShowProfileDialog(false)
        return
      }

      // Check if firstName or lastName are empty
      const firstNameEmpty = !userData.firstName || userData.firstName.trim() === ''
      const lastNameEmpty = !userData.lastName || userData.lastName.trim() === ''

      // Only show dialog if user hasn't been prompted before in this session
      const hasBeenPrompted = sessionStorage.getItem('profilePrompted') === 'true'
      
      if ((firstNameEmpty || lastNameEmpty) && !hasBeenPrompted) {
        setShowProfileDialog(true)
        // Mark as prompted to avoid showing again in this session
        sessionStorage.setItem('profilePrompted', 'true')
      } else {
        setShowProfileDialog(false)
      }
    }
  }, [userData, isGuest])

  const handleCloseDialog = () => {
    // Allow closing the dialog regardless of profile completion
    setShowProfileDialog(false)
  }

  return (
    <>
      {showProfileDialog && (
        <ProfileEditDialog 
          open={showProfileDialog} 
          onClose={handleCloseDialog}
          forceRequired={false} // Remove forced requirement
        />
      )}
    </>
  )
}

export default RequiredProfileCheck
